module.exports = __webpack_public_path__ + "9405917dd3bfd1c3acebba392fc1fb84.ttf";